import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import * as t from "io-ts";
import { fpJsonStringify } from "@/util/fp-json-stringify";

export async function logEvent(eventType: string, eventProperties = {}) {
  await makeWordPressAjaxRequest({
    action: "breakdance_track_amplitude_event",
    dataToPost: {
      eventType,
      eventProperties: fpJsonStringify(eventProperties)
    },
    decoder: t.unknown,
    resultKey: "data",
    suppressErrorLogging: true
  });
}
